"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _InfoModal = _interopRequireDefault(require("web/shared/components/InfoModal"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _jobsViewsStyles = require("web/shared/jobs/jobsViews.styles.js");
var _ScheduleCell = require("web/shared/jobs/ScheduleCell.styles");
var _stopPropagation = _interopRequireDefault(require("web/shared/utils/stopPropagation"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* A job's run-times in the overview: as many whole times as fit a fixed
* number of characters, then an ellipsis and a button that opens the full
* schedule. A schedule that fits shows whole, with no button.
*/ // The most characters the cell shows before cropping: four "HH:MM" times
// and their separators.
const MAX_SCHEDULE_CHARACTERS = 26;
const SEPARATOR = ", "; /**
                        * The leading run-times whose joined text fits the maximum, never cutting a
                        * time in half; always at least the first, so a cropped cell is never empty.
                        */
function fittingTimes(schedule) {
  const fitting = [];
  let length = 0;
  for (const time of schedule) {
    const added = (fitting.length === 0 ? 0 : SEPARATOR.length) + time.length;
    if (fitting.length > 0 && length + added > MAX_SCHEDULE_CHARACTERS) {
      break;
    }
    fitting.push(time);
    length += added;
  }
  return fitting;
}
function ScheduleCell(_ref) {
  let jobKey = _ref.jobKey,
    schedule = _ref.schedule;
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const shown = fittingTimes(schedule);
  const cropped = shown.length < schedule.length;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ScheduleCell.styles.cell)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.mono)), {}, {
      children: [shown.join(SEPARATOR), cropped ? "".concat(SEPARATOR.trim(), " \u2026") : null]
    })), cropped ? /*#__PURE__*/ // The row opens the job on a click; a click here, or anywhere in the
    // dialog drawn inside this cell, is the schedule's alone.
    (0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ScheduleCell.styles.expandArea)), {}, {
      onClick: _stopPropagation.default,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        type: "button",
        "aria-label": "Show all ".concat(schedule.length, " run-times"),
        onClick: () => setOpen(true)
      }, stylex.props(_ScheduleCell.styles.expandButton)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          name: "expand",
          size: "xs"
        })
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InfoModal.default, {
        open: open,
        title: "".concat(jobKey, " schedule"),
        closeLabel: "Close",
        onClose: () => setOpen(false),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ScheduleCell.styles.summary)), {}, {
          children: [schedule.length, " runs a day, in server time."]
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ScheduleCell.styles.times)), {}, {
          children: schedule.map((time, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_jobsViewsStyles.styles.mono, _ScheduleCell.styles.time)), {}, {
            children: time
          }), "".concat(index, "-").concat(time)))
        }))]
      })]
    })) : null]
  }));
}
var _default = exports.default = ScheduleCell;